import { styled } from '@mui/material/styles';
import {
  Box,
  DialogTitle,
  IconButton,
  Stepper,
  Step,
  StepButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PREFIX = 'FullscreenDialogHeader';

const classes = {
  header: `${PREFIX}-header`,
  controls: `${PREFIX}-controls`,
  content: `${PREFIX}-content`,
  heading: `${PREFIX}-heading`,
  aside: `${PREFIX}-aside`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
};

interface FullscreenDialogHeaderProps {
  title: string;
  subTitle?: string;
  close: () => void;
  children?: React.ReactNode;
}

const Root = styled(DialogTitle)(({ theme }) => ({
  [`&.${classes.header}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    padding: 0,
    paddingLeft: theme.spacing(18),
  },

  [`& .${classes.controls}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  [`& .${classes.content}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      marginRight: 144,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 32,
    },
    marginBottom: 16,
    marginTop: -12,
    fontFamily: 'Bitter',
  },

  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
  },

  [`& .${classes.subTitle}`]: {
    textTransform: 'uppercase',
    fontWeight: 600,
  },
}));

export function FullscreenDialogHeader({
  title,
  subTitle,
  close,
  children,
}: FullscreenDialogHeaderProps) {
  const handleClose = () => {
    close();
  };

  return (
    <Root className={classes.header}>
      <Box className={classes.controls}>
        <IconButton
          onClick={handleClose}
          aria-label="close"
          data-testid="close"
          size="large">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className={classes.content}>
        <Box className={classes.heading}>
          <Typography variant="body2" className={classes.subTitle}>
            {subTitle}
          </Typography>
          <Typography variant="h1" className={classes.title}>
            {title}
          </Typography>
        </Box>
        <Box className={classes.aside}>{children}</Box>
      </Box>
    </Root>
  );
}
